module.exports = __webpack_public_path__ + "static/img/kajkasjas1221212.4e67597e.jpg";